import { render, staticRenderFns } from "./IconSvgNotifications.vue?vue&type=template&id=65a13b63&scoped=true&"
import script from "./IconSvgNotifications.vue?vue&type=script&lang=js&"
export * from "./IconSvgNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a13b63",
  null
  
)

export default component.exports